import * as React from 'react';

import styles from './appFileField.module.scss';
import { AppFormField, AppFormFieldProps, AppFormFieldOwnProps } from './appFormField';

export interface AppFileFieldOwnProps extends AppFormFieldOwnProps {
  extensions?: string[];
}

export class AppFileField extends AppFormField<AppFileFieldOwnProps> {
  private selectedFileName: string;

  protected renderInput(field: AppFormFieldProps): JSX.Element {
    const inputProps = { ...field.input };
    const currentFile = inputProps.value;
    delete inputProps.value;

    return (
      <>
        {!this.selectedFileName && currentFile && (
          <p>
            Current: <img src={currentFile} className={styles.filePreview} alt="" />
          </p>
        )}
        {!field.disabled && (
          <div className="custom-file">
            <input
              {...inputProps}
              type="file"
              onChange={this.adaptFileEventToValue(inputProps.onChange)}
              onBlur={this.adaptFileEventToValue(inputProps.onBlur)}
              className="custom-file-input"
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label className="custom-file-label">{this.getFileName(field)}</label>
          </div>
        )}
      </>
    );
  }

  private adaptFileEventToValue = (delegate: any) => (e: any) => {
    const file = e.target.files[0];
    delegate(file);
    this.selectedFileName = file ? file.name : undefined;
  };

  // eslint-disable-next-line no-unused-vars
  private getFileName(field: any) {
    if (this.selectedFileName) {
      return this.selectedFileName;
    }

    return 'Choose File';
  }
}
